<template>
  <v-container>
    <!-- Top Section -->
    <div class="landing-page__header">
      <v-col class="landing-page__info">
        <div>
          <h1><span id="gap">Nutri</span><span id="gap">Gap</span></h1>
          <h2>{{$t('landingPage.header.subtext')}}</h2>
          <span id="subtext">
            <ul>
              <li><span id="underscore">_</span>{{$t('landingPage.header.li1')}}</li>
              <li><span id="underscore">_</span>{{$t('landingPage.header.li2')}}</li>
              <li><span id="underscore">_</span>{{$t('landingPage.header.li3')}}</li>
            </ul>
          </span>
        </div>
      </v-col>
      <v-col class="landing-page__register">
        <div>
          <router-link to="/user/register">
            {{$t('landingPage.header.register')}} <v-icon>mdi-arrow-right</v-icon>
          </router-link>
        </div>
      </v-col>
    </div>
    <!-- Bottom Section -->
    <div class="landing-page__info-content">
      <h2>{{$t('landingPage.info.headline')}}</h2>
      
      <v-row>
        <v-col>
          <div class="circle">
            <span class="circle-text">
              {{$t('landingPage.info.col1')}}
              <img class="instructions-icon" src="../assets/Icon_Abschaetzen.svg" />
            </span>
          </div>
        </v-col>

        <v-col>
          <div class="circle">
            <span class="circle-text">
              {{$t('landingPage.info.col2')}}
              <img class="instructions-icon" src="../assets/Icon_Optimieren.svg" />
            </span>
          </div>
        </v-col>

        <v-col>
          <div class="circle">
            <span class="circle-text">
              {{$t('landingPage.info.col3')}}
              <img class="instructions-icon" src="../assets/Icon_Decken.svg" />
            </span>
          </div>
        </v-col>

        <v-col>
          <div class="circle">
            <span class="circle-text">
              {{$t('landingPage.info.col4')}}
              <img class="instructions-icon" src="../assets/Icon_Berechnen.svg" />
            </span>
          </div>
        </v-col>
      </v-row>
    </div>

    <div class="landing-page__instructions">
      <h2>{{$t('landingPage.instructions.headline')}}</h2>
      <ol>
        <li>
          {{$t('landingPage.instructions.li1')}}
          <router-link to="user/register"> 
            {{$t('landingPage.instructions.register')}} <v-icon>mdi-arrow-right</v-icon>
          </router-link>
        </li>
        
        <li>
          <span>
          {{$t('landingPage.instructions.li2')}}
          </span>
        </li>

        <li>
          {{$t('landingPage.instructions.li3')}}
        </li>

        <li>
          {{$t('landingPage.instructions.li4')}}
        </li>
          
        <li>
          {{$t('landingPage.instructions.li5')}}
        </li>

        <li>
          {{$t('landingPage.instructions.li6')}}
        </li>

        <li>
          {{$t('landingPage.instructions.li7')}}
          <p>
            {{$t('landingPage.instructions.li7-2')}}
            <a :href="'About_NutriGap_'+$i18n.locale+'.pdf'" target="_blank" download> {{$t('landingPage.instructions.li7-link')}}</a>.
          </p>
        </li>

      </ol>
    </div>
  </v-container>
</template>

<script>
export default {
}
</script>
